import React from 'react';
import { Calendar } from 'lucide-react';

/**
 * Componente para exibir o intervalo de datas consultado
 * @param {Object} props
 * @param {string} props.start - Data inicial no formato YYYY-MM-DD
 * @param {string} props.end - Data final no formato YYYY-MM-DD
 * @param {string} props.className - Classes CSS adicionais
 */
const PeriodoDisplay = ({ start, end, className = '' }) => {
  // Formatar data para formato brasileiro
  const formatarData = (dataStr) => {
    if (!dataStr) return '';
    const [ano, mes, dia] = dataStr.split('-');
    return `${dia}/${mes}/${ano}`;
  };

  // Calcular número de dias
  const calcularDias = () => {
    if (!start || !end) return null;
    const inicio = new Date(start);
    const fim = new Date(end);
    const diffTime = Math.abs(fim - inicio);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 para incluir ambos os dias
    return diffDays;
  };

  const dias = calcularDias();
  const dataInicioFormatada = formatarData(start);
  const dataFimFormatada = formatarData(end);

  if (!start || !end) {
    return null;
  }

  return (
    <div className={`inline-flex max-w-full items-center gap-2 px-3 py-1.5 bg-[color:var(--accent)]/10 border border-[color:var(--accent)]/35 rounded-md ${className}`}>
      <Calendar className="h-4 w-4 shrink-0 text-[color:var(--accent)]" />
      <div className="flex flex-wrap items-center gap-x-2 text-sm tabular-nums">
        <span className="font-medium text-[color:var(--text-primary)]">
          {dataInicioFormatada}
        </span>
        <span className="text-[color:var(--text-muted)]">→</span>
        <span className="font-medium text-[color:var(--text-primary)]">
          {dataFimFormatada}
        </span>
        {dias && (
          <>
            <span className="text-[color:var(--text-muted)]">•</span>
            <span className="text-xs text-[color:var(--accent)]">
              {dias} {dias === 1 ? 'dia' : 'dias'}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default PeriodoDisplay;

